import './App.less';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './layout/Navbar';
import Home from './pages/Home';
import SearchBus from './pages/SearchBus';
import ContactUs from './pages/ContactUs';

function App() {
  return (
    <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/search-bus" element={<SearchBus/>} />
        <Route path="/contact-us" element={<ContactUs/>} />
      </Routes>
    </div>
  );
}

export default App;
